<template>
  <div class="wrapper">
    <div class="headerTop">
      <div class="checked">
        <a-icon type="barcode" />
        <div class="headerText">检测</div>
      </div>
      <div class="headerText2">良品率</div>
    </div>
    <div class="content" v-for="item in data" :key="item.index">
      <div class="progress">
        <div class="progressInfo">
          <div class="progressName">{{item.progressName}}</div>
          <div class="progressDetail">{{item.progressDetail | toPrecent2}}</div>
        </div>
        <a-progress :percent="item.precent" :strokeWidth = '5' :showInfo="false" style="margin-left: 15px" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    data: {
      type: Array,
    },
  },
};
</script>
<style scoped>
.wrapper {
  width: 100%;
  background-color: #202834;
  height: 325px;
  overflow-y: scroll;
  position: relative;
  right: -23px;
  padding-right: 25px;
}
.headerTop {
  color: #fff;
  display: flex;
  align-items: center;
  font-size: 16px;
  padding: 0 15px;
  justify-content: space-between;
}
.checked {
  display: flex;
  align-items: center;
}
.headerText {
  padding-left: 15px;
}
.headerText2 {
  font-size: 13px;
  color: #2a6582;
}
.progressInfo {
  display: flex;
  justify-content: space-between;
}
.progressName {
  color: #fff;
  padding-left: 10px;
}
.progressDetail {
  color: #3da2ce;
  padding-right: 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/test10Children/checked.vue